var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7037 3C6.45818 3 3 6.45818 3 10.7037C3 14.9492 6.45818 18.4074 10.7037 18.4074C12.5499 18.4074 14.2454 17.7518 15.5742 16.6635L20.1738 21.2631C20.2448 21.3371 20.3298 21.3961 20.4239 21.4368C20.518 21.4774 20.6192 21.4989 20.7217 21.5C20.8242 21.501 20.9259 21.4816 21.0208 21.4428C21.1157 21.4041 21.2019 21.3468 21.2743 21.2743C21.3468 21.2019 21.4041 21.1157 21.4428 21.0208C21.4816 20.9259 21.501 20.8242 21.5 20.7217C21.4989 20.6192 21.4774 20.518 21.4368 20.4239C21.3961 20.3298 21.3371 20.2448 21.2631 20.1738L16.6635 15.5742C17.7518 14.2454 18.4074 12.5499 18.4074 10.7037C18.4074 6.45818 14.9492 3 10.7037 3ZM10.7037 4.54074C14.1165 4.54074 16.8666 7.29086 16.8666 10.7037C16.8666 14.1165 14.1165 16.8666 10.7037 16.8666C7.29086 16.8666 4.54074 14.1165 4.54074 10.7037C4.54074 7.29086 7.29086 4.54074 10.7037 4.54074Z",
    fill: "#4A5056",
    stroke: "#4A5056",
    strokeWidth: 0.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.3cba2582f7915d9820a50798bf26717e.svg";
export { ForwardRef as ReactComponent };